import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $VatInfoModuleName } from "./vatInfo.types";

const getVatInfoFor = (vatNr?: string | null) => (state: IState) => {
    const data = getValueState(state, $VatInfoModuleName)?.data;
    if (data && data.vatNr === vatNr) {
        return data;
    }

    return null;
};

const isLoading = (state: IState) => {
    return !!getValueState(state, $VatInfoModuleName)?.isLoading;
};

export { getVatInfoFor, isLoading };
